export const LETTERS_MASK = /^[a-zA-ZÀ-ÿ- \u00f1\u00d1]+$/
export const PHONE_MASK = '000 000 0000'
export const sanitizeNumber = (number = '', placeholderChar = '_'): string => {
  return number.replace(/ /g, '').replace(new RegExp(placeholderChar), '')
}
export const CLABE_MASK = '000 000 00000000000 0'
